"use strict";
/* Generated by ts-generator ver. 0.0.8 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GebProxyRegistry = void 0;
var geb_contract_base_1 = require("@reflexer-finance/geb-contract-base");
var GebProxyRegistry = /** @class */ (function (_super) {
    __extends(GebProxyRegistry, _super);
    function GebProxyRegistry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GebProxyRegistry.prototype.build = function () {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "build", "outputs": [{ "internalType": "address payable", "name": "proxy", "type": "address" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, []);
    };
    GebProxyRegistry.prototype.build__Address = function (owner) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }], "name": "build", "outputs": [{ "internalType": "address payable", "name": "proxy", "type": "address" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [owner]);
    };
    GebProxyRegistry.prototype.proxies = function (address, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "proxies", "outputs": [{ "internalType": "contract DSProxy", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [address], multicall);
    };
    return GebProxyRegistry;
}(geb_contract_base_1.BaseContractAPI));
exports.GebProxyRegistry = GebProxyRegistry;
